import React from 'react';
import AlertTitle from '@material-ui/lab/AlertTitle';

// Data
import { PARENT_HOME_ROUTE } from '../../../../_configuration';
import { messages } from './parent-login-notice.messages';

// Components
import { IntlMsg } from '../../_core/IntlMsg/intl-msg.component';
import { ParentLoginAlert, ParentLoginLink } from './parent-login-notice.styles';

// Staff auth pages only — parents land here by mistake. /parent bounces a signed-out parent to its login.
export const ParentLoginNotice: React.FC = () => (
  <ParentLoginAlert severity="warning" variant="filled">
    <AlertTitle><IntlMsg {...messages.title} /></AlertTitle>
    <IntlMsg {...messages.body} />
    <div>
      <ParentLoginLink to={PARENT_HOME_ROUTE}>
        <IntlMsg {...messages.btnGoToParent} />
      </ParentLoginLink>
    </div>
  </ParentLoginAlert>
);
